// Maps service slug → related in-house guides. Used to link the guide from
// service, area, and area×service landing pages for internal discoverability.
export type ServiceGuideLink = {
  slug: string;
  title: string;
  blurb: string;
};

export const SERVICE_GUIDES: Record<string, ServiceGuideLink[]> = {
  "oven-cleaning": [
    {
      slug: "oven-cleaning-prices-southend",
      title: "Oven cleaning prices in Southend (2026)",
      blurb:
        "What a single, double or range oven clean really costs across SS0–SS9 — plus what changes the price.",
    },
  ],
};

export function getServiceGuides(serviceSlug: string): ServiceGuideLink[] {
  return SERVICE_GUIDES[serviceSlug] ?? [];
}
